import { Box } from '@chakra-ui/react';
import React from 'react';
import { DanIcon } from '../icons/Icons';

export interface HeaderProps {
  onClick?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onClick }) => (
  <Box w="full">
    <DanIcon w="60px" h="60px" onClick={() => onClick && onClick()} cursor={onClick && 'pointer'} />
  </Box>
);
